import moment from 'moment-timezone';
import React from 'react';
import DayPicker from 'react-day-picker';

class PreferredDateFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDatePicker: false,
    };
  }

  onClearDate = (e) => {
    e.preventDefault();
    this.onDayClick('');
  };

  onDayClick = (date) => {
    this.props.onDateChange(date);
    this.setState({
      showDatePicker: false,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const isFilterOpened = !prevProps.isFilterOpen && this.props.isFilterOpen;
    const isDatePickerOpened = !prevState.showDatePicker && this.state.showDatePicker && this.props.isFilterOpen;
    if (isFilterOpened) {
      this.setState({
        showDatePicker: false,
      });
    } else if (isDatePickerOpened) {
      this.props.onFilterChange();
    }
  }

  onMoveInDateToggle = (e) => {
    e.preventDefault();
    this.setState({ showDatePicker: !this.state.showDatePicker });
  };

  selectedDateToday = () => {
    const today = moment();
    return this.props.selectedDate && moment(this.props.selectedDate).isSame(today, 'day');
  };

  styles = {
    buttonText: {
      height: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'lighter',
    },
    dateFilter: {
      position: 'relative',
    },
    datePicker: {
      position: 'absolute',
      left: 0,
      marginTop: '1rem',
      padding: '0.75rem 1.25rem',
      backgroundColor: '#f4f4f7',
      borderRadius: '1rem',
      boxShadow: '0 5px 10px rgba(0,0,0,0.3)',
      fontWeight: 'light',
      maxHeight: '65vh',
      overflow: 'auto',
    },
    selectedDateText: {
      marginLeft: '0.5rem',
      textDecoration: 'underline',
    },
    modifiersStyles: {
      selectedDate: {
        backgroundColor: '#ffc107',
      },
    },
  };

  buttonText() {
    return [
      'Move in from:',
      !this.props.selectedDate && 'Anytime',
      this.selectedDateToday() && 'Today',
      !this.selectedDateToday() && this.props.selectedDate && `${moment(this.props.selectedDate).format('DD/MM/YYYY')}`,
    ].filter(Boolean);
  }

  render() {
    const [moveInText, moveInDate] = this.buttonText();
    const modifiers = {
      selectedDate: this.props.selectedDate,
    };

    const modifiersStyles = {
      selectedDate: {
        backgroundColor: '#FFB08F',
      },
    };

    return (
      <div className="preferred-date" style={this.styles.dateFilter}>
        <button
          className="preferences-pane__option-button preferred-date__button--primary-active"
          style={this.styles.button}
          onClick={this.onMoveInDateToggle}
        >
          <span style={this.styles.buttonText}>{moveInText}</span>
          {moveInDate && <span style={this.styles.selectedDateText}>{moveInDate}</span>}
        </button>
        {this.state.showDatePicker && (
          <div style={this.styles.datePicker}>
            <DayPicker
              disabledDays={{ before: new Date() }}
              onDayClick={this.onDayClick}
              modifiers={modifiers}
              modifiersStyles={modifiersStyles}
              month={this.props.selectedDate}
            />
            <a className="preferred-date__clear" href="#" onClick={this.onClearDate}>
              Clear Date
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default PreferredDateFilter;
